import { api } from "../lib/api.js";

interface AppLogs {
  status: string;
  status_message?: string;
  logs?: string;
}

export async function logsCommand(appId: string): Promise<void> {
  const res = await api.get(`/v1/apps/${appId}/logs`);
  if (!res.ok) {
    console.error("Failed to fetch logs.");
    process.exit(1);
  }

  const data = (await res.json()) as AppLogs;

  console.log(`Status: ${data.status}`);
  if (data.status_message) {
    console.log(`Message: ${data.status_message}`);
  }
  if (data.logs) {
    console.log("\n--- Build Logs ---\n");
    console.log(data.logs);
  }
}
